import { render, staticRenderFns } from "./HandleAdmin.vue?vue&type=template&id=79d443cc&scoped=true&"
import script from "./HandleAdmin.vue?vue&type=script&lang=js&"
export * from "./HandleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HandleAdmin.vue?vue&type=style&index=0&id=79d443cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d443cc",
  null
  
)

export default component.exports